<template>
  <div class="CampusRank1">
    <div class="titlegaga">7日消费数据(金额、订单)</div>
    <div id="MonthRegister"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'MonthRegisterView',
  props: ['data'],
  data() {
    return {
      chart: null,
    };
  },
  methods: {
    initChart() {
      if (!this.chart) {
        var chartDom = document.getElementById('MonthRegister');
        this.chart = echarts.init(chartDom);
        let days = [];
        let money = [];
        let amount = [];
        this.data.forEach(element => {
          days.push(element.day);
          money.push(element.money);
          amount.push(element.amount);
        });
        var option;
        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              },
            },
          },
          legend: {
            data: ['订单数量', '消费金额'],
            textStyle:{
              color:'#fff',
              fontSize:window.outerWidth/1980*20
            }
          },
          xAxis: [
            {
              type: 'category',
              data: [...days],
              axisPointer: {
                type: 'shadow',
              },
              // axisLine: {
              //   lineStyle: {
              //     color: '#fff',
              //     fontSize:window.outerWidth/1980*16
              //   },
              // },
              nameTextStyle:{
                color:"#fff"
              },
              axisLabel:{
                fontSize:window.outerWidth/1980*16,
                color:"#fff"
              }
            },
          ],
          yAxis: [
            {
              type: 'value',
              name: '订单数量',
              show: false,
              axisLabel: {
                formatter: '{value} 笔',
              },
            },
            {
              type: 'value',
              name: '消费金额',
              show: false,
              axisLabel: {
                formatter: '{value} 元',
              },
            },
          ],
          series: [
            {
              name: '消费金额',
              type: 'bar',
              barWidth: '20%',
              label: {
                show: true,
                position: 'top',
                distance: 2,
                color:'#fff',
                fontSize:window.outerWidth/1980*16,
                formatter:(params)=>{
                  if(params.dataIndex%2!=0){
                    return params.data
                  }else{
                    return ''
                  }
                }
              },
              tooltip: {
                textStyle:{
                  color:'#fff'
                }
              },
              data: [...money],
            },
            {
              name: '订单数量',
              type: 'line',
              smooth: true,
              label: {
                show: true,
                position: 'top',
                distance: 10,
                color:'#fff',
                fontSize:window.outerWidth/1980*16,
                formatter:(params)=>{
                  if(params.dataIndex%2==0){
                    return params.data
                  }else{
                    return ''
                  }
                }
              },
              tooltip: {
                textStyle:{
                  color:'#fff'
                }
              },
              data: [...amount],
            },
          ],
        };
        option && this.chart.setOption(option);
      } else {
        this.chart.changeData(this.data);
      }
      window.onresize = () => {
          this.chart.resize();
        };
    },
  },
};
</script>
<style lang="scss" scoped>
.CampusRank1 {
  height: 100%;
  width: 100%;
}
#MonthRegister {
  height: 100%;
  width: 100%;
}
</style>
